module.exports = __webpack_public_path__ + "static/media/dont3.f50295eb.png";